// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SiteSearchResponseModel {
    static getAttributeTypeMap() {
        return SiteSearchResponseModel.attributeTypeMap;
    }
}
SiteSearchResponseModel.discriminator = undefined;
SiteSearchResponseModel.additionalProperties = false;
SiteSearchResponseModel.attributeTypeMap = [
    {
        "name": "sites",
        "baseName": "sites",
        "type": ""
    },
    {
        "name": "hasAdditionalMatches",
        "baseName": "hasAdditionalMatches",
        "type": "boolean"
    },
];
//# sourceMappingURL=siteSearchResponseModel.js.map